import { useContext } from 'react';

import { AdvisorContext } from './advisorContextValue';

export function useAdvisor() {
  const context = useContext(AdvisorContext);
  if (context === undefined) {
    throw new Error('useAdvisor must be used within an AdvisorProvider');
  }
  return context;
}

export function useAdvisorOptional() {
  return useContext(AdvisorContext);
}
